import React, {
  useState,
  memo,
  useCallback,
  useEffect,
  useMemo,
  Fragment,
} from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ServiceBase, { checkNetworkConnection } from "utils/ServiceBase";
import icon_toast_success from "assets/icon_toast_success.png";
import icon_tipping_title from "assets/icon_tipping_title.png";
import ModalTipping from "containers/tipping/index";
import { Modal, notification } from "antd";

// images
import icon_ring from "assets/icon_ring.png";
import icon_dot from "assets/icon_dot.png";

// components
import Header from "components/headers";
import ModalContent from "components/modal";
import ModalLoading from "components/modal/Loading";
// contanst
import formatNumber from "utils/formatNumber";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
// actions
import {
  pushApiErrorData,
  setApiErrorOpen,
  setHomeBrand,
  setOpenNoInternetModal,
} from "redux/action";
import { useDispatch } from "react-redux";
import { setMenuVersion } from "redux/action";
import { useTranslation } from "react-i18next";

const OrderSuccess = memo(({ className }) => {
  const navigate = useNavigate();
  const homeBrand = useSelector((state) => state.rootReducer.homeBrand);
  const dispatch = useDispatch();

  const [itemSelected, setItemSelected] = useState(null);
  const { t } = useTranslation("translation");
  const [isShowModalTipping, setShowModalTipping] = useState([false, false]);

  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState([]);
  const location = useLocation();
  const search = location?.search || "";
  const valueQueryUrl = queryString.parse(search);
  const valueUrl = valueQueryUrl?.qrCode?.split("__");

  const handlePushApiError = (api) => {
    dispatch(pushApiErrorData([api]));
  };

  const handleShowApiErrors = () => {
    notification.close("internalServerError");
    dispatch(setApiErrorOpen(true));
  };

  const handleCheckNetworkConnect = () => {
    if (checkNetworkConnection()) return true;
    else {
      dispatch(setOpenNoInternetModal(true));
      return false;
    }
  };

  const openModal = (item) => {
    setItemSelected({ ...item });
    setIsOpen(true);
  };
  const onCancelModalTiping = () => {
    setShowModalTipping([false, false]);
  };

  const onShowModalTipping = () => {
    setShowModalTipping([true, false]);
  };

  const onCancelModal = (item) => {
    setIsOpen(false);
    setItemSelected(null);
  };

  const qrCode = useMemo(() => {
    if (valueUrl && valueUrl?.[0]) {
      return valueUrl?.[0];
    } else if (homeBrand) {
      return homeBrand.qrCode;
    } else {
      return "";
    }
  });
  const restaurantCode = useMemo(() => {
    if (valueUrl && valueUrl?.[1]) {
      return valueUrl?.[1];
    } else if (homeBrand) {
      return homeBrand.restaurantCode;
    } else {
      return "";
    }
  });

  useEffect(async () => {
    if (restaurantCode && qrCode) {
      localStorage.setItem("restaurantCode", restaurantCode);
      await getData();
    }
  }, [restaurantCode, qrCode]);

  const getData = async () => {
    if (!handleCheckNetworkConnect()) return;

    const url = `/ggg/api/v2.0/qr-order/order-overview?guid=%7B${qrCode}%7D&res-code=${restaurantCode}`;
    const response = await ServiceBase.requestJson({
      method: "GET",
      url,
      data: {},
      restaurantCode: restaurantCode,
    });
    if (response?.value?.code == "200") {
      if (
        response?.value?.data?.["category-code"] !==
        homeBrand?.["category-code"]
      ) {
        dispatch(setMenuVersion(0));
      }

      dispatch(
        setHomeBrand({
          ...response?.value?.data,
          qrCode,
          restaurantCode,
        })
      );
      console.log(response?.value?.data?.["order-status"]);
      if (response?.value?.data?.["order-status"] !== 1) {
        // order-status: 1 // bàn đang mở, 2: hủy, 3: đã đóng
        navigate("/thank-for-visiting", {
          state: {
            tableName: response?.value?.data?.["table-name"] || "",
          },
        });
      } else {
        // if (response?.value?.data?.["bill"] === 1) {
        //   navigate("/bill");
        // }
      }
    } else {
      setLoading(false);
      if (response?.value?.mess || response?.value?.message) {
        toast.error(
          response?.value?.mess || response?.value?.message || t("error")
        );
      } else {
        handlePushApiError({ url, time: Date.now() });
        notification["error"]({
          key: "internalServerError",
          message: t("internalServerError"),
          duration: 15,
          description: (
            <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
              {t("forDev")}
            </span>
          ),
        });
      }
      if (response?.value?.code === "401") {
        navigate("/not-found", {});
      }
    }
  };

  const onConfirmModal = async () => {
    let mess = "...";
    if (itemSelected?.delivered == itemSelected?.quantity) {
      // đã phục vu
      mess = `${t("table")} ${orderSuccess?.table?.name} ${t(
        "notifyRestaurant"
      )} ${itemSelected?.["menu-item"]?.name} ${t("notOutYet")}`;
    } else {
      // đang phục vụ
      mess = `${t("table")} ${orderSuccess?.table?.name} ${t(
        "promptingOutDishes"
      )} ${itemSelected?.["menu-item"]?.name}`;
    }
    setIsOpen(false);
    const response = await callStaff(mess);
    if (response?.value?.code == "200") {
      toast.success(
        <div className="font-500 text-black">{t("noticeToRes")}</div>,
        {
          icon: () => <img src={icon_toast_success} />,
          className: "toast_one_line",
        }
      );
    }
    await setItemSelected(null);
  };

  const onOrderMore = useCallback(() => {
    navigate("/products");
  }, []);

  const onCallStaff = useCallback(async () => {
    // navigate("/call-staff");
    const response = await callStaff(
      `${t("table")} ${orderSuccess?.table?.name} ${t("paymentRequest")}`
    );
    if (response?.value?.code === "200") {
      toast.success(
        <div className="font-500 text-black">
          {t("callPaymentSuccess")}
        </div>,
        {
          icon: () => <img src={icon_toast_success} />,
          className: "toast_one_line",
        }
      );
      // notification.open({
      //   message: "Gọi thanh toán thành công",
      //   description: " ",
      //   icon: (
      //     <CheckCircleFilled
      //       style={{ color: "#47C751", background: "#ffffff" }}
      //     />
      //   ),
      // });
    }
    setShowModalTipping([true, true]);
  }, [orderSuccess?.table?.name]);

  const callStaff = useCallback(
    async (messageForStaff) => {
      if (!handleCheckNetworkConnect()) return;
      setLoading(true);
      const payload = {
        guid: `%7B${homeBrand?.qrCode}%7D`,
        content: messageForStaff,
        "employee-code": orderSuccess?.waiter?.code,
      };

      const response = await ServiceBase.requestJson({
        method: "POST",
        url: `/ggg/api/v2.0/qr-order/create-noti`,
        data: payload,
      });
      await setLoading(false);
      if (response?.code === "ECONNABORTED") {
        const url = `/ggg/api/v2.0/qr-order/create-noti`;
        handlePushApiError({ url, time: Date.now() });
        notification["error"]({
          key: "internalServerError",
          message: t("internalServerError"),
          duration: 15,
          description: (
            <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
              {t("forDev")}
            </span>
          ),
        });
      }
      return response;
    },
    [homeBrand?.qrCode, orderSuccess?.waiter?.code]
  );

  const getOrderSuccess = useCallback(async () => {
    if (!handleCheckNetworkConnect()) return;

    const url = `/ggg/api/v2.0/qr-order/order-detail?guid=%7B${homeBrand?.qrCode}%7D`;
    const response = await ServiceBase.requestJson({
      method: "GET",
      url,
      data: {},
    });
    if (response?.value?.data) {
      if (response?.value?.data?.status === 1) {
        //order-status: 1  // bàn đang mở, 2: hủy, 3: đã đóng
        response?.value?.data?.["lst-session"]?.map((order) =>
          order?.["lst-dish"].map((item, index) => {
            if (item?.delivered > 0 && item?.quantity > 1) {
              let itemClone = { ...item };
              itemClone.quantity = item.delivered;
              item.quantity = item.quantity - item.delivered;
              item.delivered = 0;
              order?.["lst-dish"].push(itemClone);
            }
          })
        );
        setOrderSuccess(response?.value?.data);
      } else {
        navigate("/thank-for-visiting", {
          state: {
            tableName: response?.value?.data?.["table-name"] || "",
          },
        });
      }
    } else {
      if (response?.value?.mess) {
        toast.error(response?.value?.mess || response?.message || t("error"));
      } else {
        handlePushApiError({ url, time: Date.now() });
        notification["error"]({
          key: "internalServerError",
          message: t("internalServerError"),
          duration: 15,
          description: (
            <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
              {t("forDev")}
            </span>
          ),
        });
      }
    }
  }, []);

  useEffect(() => {
    getOrderSuccess();
  }, []);

  const renderStatus = (delivered, quantity) => {
    if (delivered == quantity) {
      return <div className="status status_3 text-center">{t("served")}</div>;
    } else {
      return (
        <div className="status status_2 text-center">{t("inService")}</div>
      );
    }
  };

  const renderRing = (item) => {
    return (
      <div
        onClick={() => openModal(item)}
        className="w-full flex justify-center items-center cursor-pointer pt-1"
      >
        <img src={icon_ring} className="w-5" alt="icon ring" />
      </div>
    );
  };

  const renderAlertModal = useMemo(() => {
    if (itemSelected?.delivered === itemSelected?.quantity) {
      return t("notifyRestaurantDish");
    } else {
      return t("notifyRestaurantDishOutYet");
    }
  }, [itemSelected]);

  const renderPrice = (price) => {
    if (price == 0) {
      return "Buffet";
    } else {
      return `${formatNumber(price)}đ`;
    }
  };

  const renderTotalPrice = useMemo(() => {
    let price = 0;
    orderSuccess?.["lst-session"]?.map((itemSession) => {
      itemSession?.["lst-dish"].map((item) => {
        if (item?.["is-combo"]) {
          // case là món combo
          const itemCombo = itemSession?.combos.find(
            (x) => x?.["line-guid"] == item?.["line-guid"]
          );
          if (itemCombo?.["price-fix"]) {
            price = itemCombo?.price * itemCombo?.quantity + price;
          } else {
            //
            const sumComponents = itemCombo?.components.reduce(
              (accumulator, itemComponent) => {
                return accumulator + itemComponent.price;
              },
              0
            );
            price = sumComponents + price;
          }
        } else {
          // case món thường
          price =
            (item?.quantity > 0 ? item?.price * item?.quantity : 0) + price;
        }
      });
    });
    return price;
  }, [orderSuccess]);

  const renderItem = (item, index) => {
    return (
      <Fragment key={index}>
        <tr style={item?.["lst-modi"]?.length > 0 ? { border: "none" } : {}}>
          <td
            style={item?.["lst-modi"]?.length > 0 ? { paddingBottom: 0 } : {}}
          >
            <span className="font-700 ">
              <span className="quantity	">{item?.quantity}x&nbsp;</span>
              <span className="font-500	">
                {item?.["menu-item"]?.name}&nbsp;
              </span>
              <span className="quantitative font-500	">
                {item?.quantitative} {item?.unitText}
              </span>
            </span>
            <div className="font-500 color_price">
              {renderPrice(item?.price)}
            </div>
          </td>
          <td style={{ width: 110 }}>
            {renderStatus(item?.["delivered"], item?.["quantity"])}
          </td>
          <td style={{ width: "100px" }}>{renderRing(item)}</td>
        </tr>
        {item?.["lst-modi"]?.length > 0 && (
          <tr>
            <td colSpan={3} style={{ paddingTop: 0 }}>
              {item?.["lst-modi"]?.map((itemModi, indexModi) => (
                <span key={indexModi} className="item_modifi font-400 fs-12">
                  {itemModi?.modifier?.name}
                  {","}&nbsp;
                </span>
              ))}
            </td>
          </tr>
        )}
      </Fragment>
    );
  };

  const renderItemCombo = (item, index, combos) => {
    const itemCombo = combos.find(
      (x) => x?.["line-guid"] == item?.["line-guid"]
    );
    return (
      <React.Fragment key={index}>
        <tr style={{ border: "none" }}>
          <td style={{ width: "130px" }} colSpan={3}>
            <div tyle={{ width: "130px" }}>
              <div className="font-700 ">
                <span className="quantity	">{item?.quantity}x&nbsp;</span>
                {item?.["menu-item"]?.name}
              </div>
              <div className="font-500 color_price">
                {renderPrice(item?.price)}
              </div>
            </div>
          </td>
        </tr>
        {itemCombo?.components?.map((itemFood, indexCombo) => (
          <tr
            key={indexCombo}
            style={
              item?.items?.length - 1 == indexCombo ? {} : { border: "none" }
            }
          >
            <td style={{ width: "130px" }}>
              <div className="flex" style={{ width: "130px" }}>
                <img
                  src={icon_dot}
                  className="w-1 h-1 mt-2 mr-1"
                  alt="icon dot"
                />
                <span className="font-700 ">
                  <span className="quantity	">
                    {itemFood?.quantity * item?.quantity}x&nbsp;
                  </span>
                  <span className="font-500	">
                    {itemFood?.["menu-item"]?.name}&nbsp;
                  </span>
                  <span className="quantitative font-500">
                    {itemFood?.quantitative} {itemFood?.unitText}
                  </span>
                </span>
              </div>
            </td>
            <td>
              {renderStatus(itemFood?.["delivered"], itemFood?.["quantity"])}
            </td>
            <td>{renderRing(itemFood)}</td>
          </tr>
        ))}
      </React.Fragment>
    );
  };
  return (
    <div className={className}>
      {loading && <ModalLoading />}
      <div className="box">
        <div className="row header">
          <Header
            title={`${t("orderedDishTable")} ${
              orderSuccess?.table?.name || ""
            }`}
            styleIconBack={{ width: 57 }}
            rightComponent={
              <div
                onClick={onOrderMore}
                className="order_more cursor-pointer font-700"
              >
                {t("orderMoreDishes")}
              </div>
            }
          />
        </div>
        <div className="row tipping">
          <div className="flex justify-between items-center padding_content view_bottom">
            <div>
              <div className="flex justify-between">
                <img
                  src={icon_tipping_title}
                  className="img-tipping-logo"
                  alt="info"
                />
                <div className="tippingInfo font-500 fs-16">
                  {t("tippingInfo")}&nbsp;
                </div>
              </div>
            </div>
            <div
              onClick={onShowModalTipping}
              className="btn_primary font-700 cursor-pointer bt-tipping"
            >
              {t("tippingNow")}
            </div>
          </div>
        </div>
        <Modal
          destroyOnClose
          maskStyle={{ borderRadius: 20 }}
          open={isShowModalTipping[0]}
          footer={null}
          centered
          closable={false}
          onCancel={onCancelModalTiping}
          className={"custom-modal-product modal-product-combo"}
        >
          <ModalTipping
            isShow={isShowModalTipping[1]}
            onClose={onCancelModalTiping}
          />
        </Modal>
        <div className="row content">
          <div className="view_content px-4">
            <table>
              <tr className="tr_header font-bold">
                <th className="fs-12 text-left">{t("dishName")}</th>
                <th className="fs-12 text-left">{t("status")}</th>
                <th className="fs-12 text-center">{t("invoke")}</th>
              </tr>
              {orderSuccess?.["lst-session"]?.map((order) =>
                order?.["lst-dish"].map((item, index) => {
                  if (
                    item?.["menu-item"]?.code === "1122639" ||
                    item?.["menu-item"]?.code === "1122638" ||
                    item?.quantity === 0
                  )
                    return;
                  return item?.["is-combo"]
                    ? renderItemCombo(item, index, order?.combos)
                    : renderItem(item, index);
                })
              )}
            </table>
          </div>
        </div>

        <div className="row footer">
          <div className="flex justify-between items-center padding_content view_bottom">
            <div>
              <div className="font-500 fs-18">
                {t("total")}:&nbsp;
                <span className="font-700 color_primary fs-20">
                  {formatNumber(renderTotalPrice)}đ
                </span>
              </div>
            </div>
            <div
              onClick={onCallStaff}
              className="btn_primary font-700 px-3 cursor-pointer py-3"
            >
              {t("callPay")}
            </div>
          </div>
        </div>
      </div>
      <ModalContent
        modalIsOpen={modalIsOpen}
        title={renderAlertModal}
        titleConfirm={t("ok")}
        titleCancel={t("cancel")}
        isShowBtnCancel={true}
        onCancel={onCancelModal}
        onConfirm={onConfirmModal}
        content={""}
      />
    </div>
  );
});

export default styled(OrderSuccess)`
  height: 100%;
  .box {
    display: flex;
    flex-flow: column;
    height: 100%;
    .order_more {
      color: #0085ff;
    }
  }
  .view_content {
    table {
      width: 100%;
      .tr_header {
        border-bottom: 1px solid #f2f2f2;
      }
    }
    tr {
      width: 100%;
      border-bottom: 3px solid #f2f3f4;
      vertical-align: top;
    }
    td {
      padding-top: 12px;
      padding-bottom: 12px;
    }

    th {
      padding-top: 12px;
      padding-bottom: 12px;
    }
    .status {
      width: 110px;
      padding: 2px 1px;
    }
    .status_1 {
      background: #ececec;
      border-radius: 100px;
    }
    .status_2 {
      background: rgba(237, 76, 47, 0.1);
      border-radius: 100px;
      color: #ed4c2f;
    }
    .status_3 {
      background: rgba(35, 183, 53, 0.1);
      border-radius: 100px;
      color: #23b735;
    }
  }

  .box .row.header {
    flex: 0 1 auto;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  }

  .box .row.content {
    flex: 1 1 auto;
    overflow: auto;
  }

  .box .row.footer {
    flex: 0 1 40px;
    //margin-bottom: 10px;
    box-shadow: 0px -2px 6px rgb(0 0 0 / 2%);
    filter: drop-shadow(0px -4px 12px rgba(0, 0, 0, 0.04));
    .view_bottom {
      box-shadow: 0px -2px 6px rgb(0 0 0 / 2%);
      filter: drop-shadow(0px -4px 12px rgba(0, 0, 0, 0.04));
      padding: 10px;
    }
  }
  .box .row.tipping {
    flex: 0 1 40px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #ffe7d6;
  }
  .bt-tipping {
    width: 80px;
    padding-left: 5px;
    padding-right: 5px;
    height: 44px;
  }
  .color_price {
    color: #7f8083;
  }
  .tippingInfo {
    margin-left: 10px;
  }
  .img-tipping-logo {
    weight: 20px;
    height: 20px;
  }
  .quantity {
    color: #f26333;
  }
  .item_modifi {
    color: #7f8083;
  }
`;
